import { Component, Mixins, Prop } from '@/vue-property-decorator'
import { createSvgSprite } from '@/utils/business-utils/assets'
import { useI18n } from '@/i18n'
// const comm_img_jb_2 = createSvgSprite('comm_img_jb-2')
import { GetCssVarManager } from '../../../components/baseCssVarProvide'
import { _LabelGameStatusBase as LabelGameStatusBase } from './cssVar/labelGameStatusBase'
import { _LabelGameStatusDefault as LabelGameStatusDefault } from './cssVar/labelGameStatusDefault'
import BaseCssVarInject from '../../../components/baseCssVarInject'
import style from './style.module.scss'
export type LabelGameStatusCssVarManager = GetCssVarManager<LabelGameStatusBase>
export { LabelGameStatusBase, LabelGameStatusDefault }
/** 状态印射,因为要动态切换,所以必须是一个函数,不可是最终计算出来的值 */
type StatusMapper = {
  remenber: () => string
  update: () => string
  newOne: () => string
}
/** 状态印射(定义在外部,则它本身就将会是一个基础的单例模式) */
let statusMapper: StatusMapper
/** 状态:  remenber:推荐 update:更新 newOne:新品 */
export type GameStatus = keyof StatusMapper | undefined | null
type Props = {
  /** 状态:  remenber:推荐 update:更新 newOne:新品 */
  status?: GameStatus
}
/** 游戏卡片
 * 正方型图片,结合文字
 */
@Component<LabelGameStatus>({
  name: 'LabelGameStatus'
})
export default class LabelGameStatus extends Mixins<
  BaseCssVarInject<LabelGameStatusBase>
>(BaseCssVarInject) {
  /** 取得cssVar 默认的 */
  public static getCssVarDefault = () => new LabelGameStatusDefault()

  @Prop()
  private status!: Props['status']
  created(): void {
    // 如果它不存在,则为它赋值,单例模式,全局仅会进行一次赋值
    if (!statusMapper) {
      const { t } = useI18n()
      statusMapper = {
        remenber: () => t('lobby.game.suggest') as string,
        update: () => t('lobby.game.update') as string,
        newOne: () => t('lobby.game.new') as string
      }
    }
  }
  render() {
    const { status } = this
    /** 没有状态的话,则不显示 */
    if (!status) return <template></template>
    return (
      <div
        class={{
          [style['label-game-status']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType),
          [style['is-remenber']]: status === 'remenber',
          [style['is-update']]: status === 'update',
          [style['is-newOne']]: status === 'newOne'
        }}
      >
        <p class={style['status-text']}>{statusMapper[status]()}</p>
        <icon-sprite
          class={style['box-tail']}
          sprite={createSvgSprite('comm_img_jb-2')}
        />
      </div>
    )
  }
}
